import {
  Platform,
  StatusBar,
  View,
  Text,
  Pressable,
  Keyboard,
  KeyboardAvoidingView,
  TouchableOpacity,
} from "react-native";
import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import {
  updateData,
  updateDataImage,
} from "../../../../services/Profile/profileService";
import styles from "../../styles/profileStyle";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import CustomComponent from "../../../../components/CustomComponent";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { SafeAreaView } from "react-native-safe-area-context";

const SocialLinkAdd = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [instagram, setInstagram] = useState<string>("");
  const [twitter, setTwitter] = useState<string>("");
  const [linkedin, setLinkedin] = useState<string>("");
  const [error1, setError1] = useState("");
  const [error2, setError2] = useState("");
  const [error3, setError3] = useState("");
  const [error4, setError4] = useState("");
  const [any, setAny] = useState<string>("");

  const urlRegex = /^(https?|http):\/\/[^\s$.?#].[^\s]*$/i;
  const validateFunction = () => {
    let validate = true;

    if (instagram) {
      if (
        (instagram.startsWith("https://") ||
          instagram.startsWith("http://") ||
          instagram.startsWith("www.") ||
          instagram.includes(".com")) &&
        !urlRegex.test(instagram)
      ) {
        setError1("Please enter a valid Instagram link.");
        validate = false;
      } else if (instagram.length <= 2) {
        setError1(
          "Please enter a valid Instagram username (minimum 2 characters)."
        );
        validate = false;
      } else if (instagram.includes(" ")) {
        setError1("User name should'nt have any spaces in between");
        validate = false;
      } else {
        setError1("");
      }
    } else {
      setError1("");
    }
    if (twitter) {
      if (
        (twitter.startsWith("https://") ||
          twitter.startsWith("www.") ||
          twitter.includes(".com")) &&
        !urlRegex.test(twitter)
      ) {
        setError2("Please enter a valid Twitter link.");
        validate = false;
      } else if (twitter.length <= 2) {
        setError2(
          "Please enter a valid Twitter username (minimum 2 characters)."
        );
        validate = false;
      } else if (twitter.includes(" ")) {
        setError2("User name should'nt have any spaces in between");
        validate = false;
      } else {
        setError2("");
      }
    } else {
      setError2("");
    }
    if (linkedin) {
      if (
        (linkedin.startsWith("https://") ||
          linkedin.startsWith("www.") ||
          linkedin.includes(".com")) &&
        !urlRegex.test(linkedin)
      ) {
        setError3("Please enter a valid LinkedIn link.");
        validate = false;
      } else if (linkedin.length <= 2) {
        setError3(
          "Please enter a valid LinkedIn username (minimum 2 characters)."
        );
        validate = false;
      } else if (linkedin.includes(" ")) {
        setError3("User name should'nt have any spaces in between");
        validate = false;
      } else {
        setError3("");
      }
    } else {
      setError3("");
    }
    if (any) {
      if (!urlRegex.test(any)) {
        setError4("Please enter a valid link");
        validate = false;
      } else {
        setError4("");
      }
    } else {
      setError4("");
    }
    return validate;
  };

  const handleNextButton = async () => {
    const updateUser = {
      socialMedia: {
        instagram: instagram,
        twitter: twitter,
        linkedIn: linkedin,
        other: any,
      },
    };
    console.log(error1.length, error2.length, error3.length, error4.length);
    if (validateFunction()) {
      console.log("work");
      await updateDataImage(updateUser);
      await updateData({ steps: 7 });
      navigation.navigate("city-add" as never);
    }
  };

  const validateName = () => {
    if (
      instagram.length < 1 &&
      twitter.length < 1 &&
      linkedin.length < 1 &&
      any.length < 1
    ) {
      return false;
    } else {
      return true;
    }
  };

  const checker = async () => {
    if (
      error1.length == 0 &&
      error2.length == 0 &&
      error3.length == 0 &&
      error4.length == 0
    ) {
      return true;
    } else false;
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <Pressable onPress={Keyboard.dismiss} style={{ flex: 1 }}>
        <View
          style={{
            flex: 1,
            paddingHorizontal: 25,
            gap: 16,
          }}
        >
          <View
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <View style={{ width: "18%", backgroundColor: "black" }}></View>
            <View style={{ width: "50%" }}>
              <TopIconView
                icon={<OnBoardingIcons.NameIcon />}
                currentScreen={7}
                totalScreens={10}
              />
            </View>
            <TouchableOpacity
              onPress={() => navigation.navigate("city-add" as never)}
            >
              <Text
                style={{
                  color: "#C0A46F",
                  textDecorationLine: "underline",
                  fontSize: 15,
                }}
              >
                Skip
              </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.middleScreen}>
            <TextView
              title="Social Media Links"
              textStyle={[
                GlobalStyles.heading3,
                {
                  fontFamily: "EBGaramondSemiBold",
                  fontSize: 34,
                  lineHeight: 37,
                  letterSpacing: -0.3,
                },
              ]}
            />
            <View style={{ marginTop: 13, width: "100%", height: 48 }}>
              <CustomComponent.InputField
                placeholder="Instagram Link / Username"
                keyboardtype="default"
                onTextChange={(text: string) => {
                  setInstagram(text.trim());
                }}
                leftIcon={
                  <View
                    style={{
                      backgroundColor: Colors.white000,
                      padding: 9,
                      borderRadius: 8,
                      marginLeft: 4,
                    }}
                  >
                    <OnBoardingIcons.InstagramIconv2 />
                  </View>
                }
              />
            </View>
            {error1.length > 0 && (
              <Text style={{ color: "red" }}>{error1}</Text>
            )}
            <View style={{ marginTop: 13, width: "100%", height: 48 }}>
              <CustomComponent.InputField
                placeholder="Twitter Link / Username"
                keyboardtype="default"
                onTextChange={(text: string) => {
                  setTwitter(text.trim());
                }}
                leftIcon={
                  <View
                    style={{
                      backgroundColor: Colors.white000,
                      padding: 12,
                      borderRadius: 8,
                      marginLeft: 4,
                    }}
                  >
                    <OnBoardingIcons.TweeterIcon />
                  </View>
                }
              />
            </View>
            {error2.length > 0 && (
              <Text style={{ color: "red" }}>{error2}</Text>
            )}
            <View style={{ marginTop: 13, width: "100%", height: 48 }}>
              <CustomComponent.InputField
                placeholder="LinkedIn Link / Username"
                keyboardtype="default"
                onTextChange={(text: string) => {
                  setLinkedin(text.trim());
                }}
                leftIcon={
                  <View
                    style={{
                      backgroundColor: Colors.white000,
                      padding: 9,
                      borderRadius: 8,
                      marginLeft: 4,
                    }}
                  >
                    <OnBoardingIcons.LinkedInIcon />
                  </View>
                }
              />
            </View>
            {error3.length > 0 && (
              <Text style={{ color: "red" }}>{error3}</Text>
            )}
            <View style={{ marginTop: 13, width: "100%", height: 48 }}>
              <CustomComponent.InputField
                placeholder="Any link that helps us verify you"
                keyboardtype="default"
                onTextChange={(text) => {
                  setAny(text.trim());
                }}
                leftIcon={
                  <View
                    style={{
                      backgroundColor: Colors.white000,
                      padding: 12,
                      borderRadius: 8,
                      marginLeft: 4,
                    }}
                  >
                    <OnBoardingIcons.UrlIcon />
                  </View>
                }
              />
            </View>
            {error4.length > 0 && (
              <Text style={{ color: "red" }}>{error4}</Text>
            )}
          </View>
        </View>
        <BottomView
          enableTitle={true}
          onPress={() => handleNextButton()}
          disableBtn={true}
          bottomTitle="Having more social media links helps us with prompt verification"
          style={{ paddingBottom: 20 }}
        />
      </Pressable>
    </SafeAreaView>
  );
};

export default SocialLinkAdd;
